import { UserRole } from '@src/types/user';
import { AddManager, GetCompaniesParams, NewCompany } from './companies';
import { oliveApi } from '../index';

const url = `/admin/v1/companies`;

const createCompanyApi = async (data: NewCompany) => {
  return await oliveApi.POST<NewCompany, any>(`${url}`, { ...data });
};

const getCompaniesListApi = async (params: GetCompaniesParams) => {
  return await oliveApi.GET<GetCompaniesParams, any>(`${url}`, {
    ...params,
  });
};

const addManagerToCompanyApi = async (id: number, data: AddManager) => {
  return await oliveApi.POST<AddManager, any>(`${url}/${id}/managers`, {
    ...data,
  });
};

const getManagerListByCompanyIdApi = async (id: number) => {
  return await oliveApi.GET<any, any>(`${url}/${id}/managers`);
};

const updateManagerRoleByIdsApi = async (
  companyId: number,
  userId: number,
  role: UserRole
) => {
  return await oliveApi.PATCH<any, any>(
    `${url}/${companyId}/managers/${userId}`,
    {
      role,
    }
  );
};

const deleteManagerByUserIdApi = async (companyId: number, userId: number) => {
  return await oliveApi.DELETE<any, any>(
    `${url}/${companyId}/managers/${userId}`
  );
};

const getCompanyByUserIdApi = async (id: string) => {
  return await oliveApi.GET<any, any>(`${url}/${id}`);
};

const updateCompanyByCompanyIdApi = async (id: string, data: NewCompany) => {
  return await oliveApi.PATCH<NewCompany, any>(`${url}/${id}`, {
    ...data,
  });
};

const deleteCompanyByCompanyIdApi = async (id: number) => {
  return await oliveApi.DELETE<any, any>(`${url}/${id}`);
};

const getCompanyByCompanyIdApi = async (id: string) => {
  return await oliveApi.GET<any, any>(`${url}/${id}`);
};

export {
  createCompanyApi,
  getCompaniesListApi,
  addManagerToCompanyApi,
  getManagerListByCompanyIdApi,
  updateManagerRoleByIdsApi,
  deleteManagerByUserIdApi,
  getCompanyByUserIdApi,
  getCompanyByCompanyIdApi,
  updateCompanyByCompanyIdApi,
  deleteCompanyByCompanyIdApi,
};
